<template>
  <div v-if="visible" class="mkt-prompt" role="dialog" aria-modal="true" aria-labelledby="mkt-prompt-title">
    <div class="mkt-prompt__card">
      <h2 id="mkt-prompt-title" class="mkt-prompt__title">Akun Anda sudah jadi</h2>
      <p class="mkt-prompt__text">Satu pertanyaan: mau kami kirimi info program, promo, dan materi gratis?</p>
      <p class="mkt-prompt__consent">{{ text }}</p>
      <div class="mkt-prompt__actions">
        <button type="button" class="mkt-prompt__btn mkt-prompt__btn--ghost" :disabled="busy" @click="close">
          Tidak, terima kasih
        </button>
        <button type="button" class="mkt-prompt__btn" :disabled="busy" @click="accept">Ya, kirimi saya</button>
      </div>
      <p class="mkt-prompt__note">Bisa diubah kapan saja di Profil → Preferensi Komunikasi.</p>
    </div>
  </div>
</template>

<script>
import Api from '@/api/Api'
import { CONSENT_TEXT } from '@/utils/consent'

const FLAG = 'dl_ask_marketing'

// Asked once after a sign-up with Google (that path shows no consent checkbox; UU PDP). auth/login_google sets the
// flag when the backend says the account is new. "Ya" records consent (source google_signup); "Tidak" records
// nothing, since no row already means no consent.
export default {
  name: 'MarketingPrompt',
  data() {
    return { visible: false, busy: false, text: CONSENT_TEXT }
  },
  watch: {
    $route() {
      this.check()
    },
  },
  mounted() {
    this.check()
  },
  methods: {
    check() {
      try {
        this.visible = window.localStorage.getItem(FLAG) === '1' && !!window.localStorage.getItem('token')
      } catch (e) {
        this.visible = false
      }
    },
    close() {
      try {
        window.localStorage.removeItem(FLAG)
      } catch (e) {
        /* nothing to clean up */
      }
      this.visible = false
    },
    async accept() {
      this.busy = true
      try {
        // the text covers email and WhatsApp; the backend skips WhatsApp while the account has no phone
        await Api.post('/profile/preferensi-komunikasi', { email: true, whatsapp: true, source: 'google_signup' })
      } catch (e) {
        /* the profile tab can still turn it on */
      }
      this.busy = false
      this.close()
    },
  },
}
</script>

<style scoped>
.mkt-prompt {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(30, 31, 64, 0.45);
}
.mkt-prompt__card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 14px;
  padding: 24px 22px 18px;
  text-align: left;
  box-shadow: 0 12px 36px rgba(30, 31, 64, 0.25);
}
.mkt-prompt__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2c2d5b;
  margin: 0 0 8px;
}
.mkt-prompt__text {
  color: #2c2d5b;
  margin: 0 0 10px;
  line-height: 1.5;
}
.mkt-prompt__consent {
  color: #6f7091;
  font-size: 0.85rem;
  line-height: 1.5;
  margin: 0 0 18px;
}
.mkt-prompt__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
.mkt-prompt__btn {
  border: 1px solid #5657a5;
  background: #5657a5;
  color: #fff;
  border-radius: 8px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
}
.mkt-prompt__btn--ghost {
  background: #fff;
  color: #5657a5;
}
.mkt-prompt__note {
  color: #9a9bb3;
  font-size: 0.8rem;
  margin: 14px 0 0;
}
</style>
